// eslint-disable-next-line import/prefer-default-export
export const TOWER_URL = 'https://slot.tizeti.com/cnmaestro/Views/index.php';
